import { useState,useEffect,useRef } from 'react';  
import L from 'leaflet';
import axios from 'axios';
import {Marker, Popup } from 'react-leaflet';

const API_URL_BO=window.config.API_URL_BO;
 
const redDotIcon = L.divIcon({
  className: 'red-dot-wrapper', 
  iconSize: [15, 15],            
  iconAnchor: [12.5, 12.5],      
  html: '<div class="red-dot-marker-pulsing"></div>'
}); 

function MovingMarker({ initialPosition }) {
  
const [currentPosition, setCurrentPosition] = useState({
    lat: initialPosition[0],
    lng: initialPosition[1],
    unitlable:''
}); 
    
 const fetchNewPosition = async () => {
    try {  
       axios.get(API_URL_BO, {
            headers: { 
                'x-api-key': "Jet2~test123", 
            }
            })
            .then(response => { 
                 console.log('Data fetched successfully:', response.data); 
                 setCurrentPosition({
                    lat: parseFloat(response.data.Latitude),
                    lng: parseFloat(response.data.Longitude),
                    unitlabel:response.data.UnitLabel
                }); 
            })
            .catch(error => {
            console.error('Request failed:', error);
            });  
    } catch (err) {
      console.error("API Polling Error:", err); 
    } finally {  
    }
  };
 
    const markerRef = useRef(null);
 
    useEffect(() => {
        const interval = setInterval(() => {
             // const { lat, lng } = currentPosition; 
             fetchNewPosition();  
        }, 5000);  
        return () => clearInterval(interval);
    }, [currentPosition]); 
  
    const positionArray = [currentPosition.lat, currentPosition.lng];

    return (
        <Marker 
            position={positionArray} 
            icon={redDotIcon}
            ref={markerRef}
        > 
        <Popup>
            *{currentPosition.unitlabel}* <br /> 
        </Popup>
        </Marker>
    );
}

export default MovingMarker;